import React from 'react';
import { blockStyle, labelStyle, inputStyle, styles } from './trainAgentStyles';

export function TrainAgentArgumentsBlock({ vm }) {
  const { argumentsList, setArgument, removeArgument, addArgument } = vm;
  return (
    <div style={blockStyle}>
      <label style={labelStyle}>6. Argumentos (objeção → resposta)</label>
      {argumentsList.map((arg, i) => (
        <div key={i} style={{ display: 'flex', gap: '8px', marginBottom: '8px', alignItems: 'flex-start' }}>
          <input
            value={arg.objection}
            onChange={(e) => setArgument(i, 'objection', e.target.value)}
            placeholder="Objeção"
            style={{ ...inputStyle, flex: 1 }}
          />
          <input
            value={arg.response}
            onChange={(e) => setArgument(i, 'response', e.target.value)}
            placeholder="Resposta"
            style={{ ...inputStyle, flex: 1 }}
          />
          <button type="button" onClick={() => removeArgument(i)} style={styles.removeBtn}>
            −
          </button>
        </div>
      ))}
      <button type="button" onClick={addArgument} style={styles.smallButton}>
        + Adicionar argumento
      </button>
    </div>
  );
}
